import { render, staticRenderFns } from "./Technical.vue?vue&type=template&id=897c8488&scoped=true&"
import script from "./Technical.vue?vue&type=script&lang=js&"
export * from "./Technical.vue?vue&type=script&lang=js&"
import style0 from "./Technical.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Technical.vue?vue&type=style&index=1&id=897c8488&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897c8488",
  null
  
)

export default component.exports